import { get, writable } from 'svelte/store';
import { getUserData } from '../controllers/APIController';

const userStore = () => {
  	
	const state = null;
	const { subscribe, set, update } = writable(state);
	
    const methods = {
        async getData (userId) {
            const res = await getUserData(userId);
            console.log("userData: " + JSON.stringify(res));
            if (!res.avatar)
                res.avatar = "/assets/avatar.png";
            if (!res.name)
                res.name = res.user_id.slice(3, 9);
            set(res);        //save user data
        }
    }

    return {
        subscribe,
        update,
        ...methods
    }
}

export default userStore();